import { defineWorkspaceEntityHydration } from '#layers/runtime/public';

/** Every `MonospaceSpace` row of a workspace runtime, with its sections, for the space routes built during preparation. */
export const workspaceSpacesHydration = defineWorkspaceEntityHydration((store) => store.MonospaceSpace.query((q) => q.many({ include: { sections: {} } })), { empty: [] });
